// @flow

import React, { useCallback, useState } from 'react';

import { PLATFORM_ROOT } from '@zapier/platform/src/constants';

import Layout from './components/Layout';

import type { HeaderNav, HeaderUser } from '../../types';

type HeaderProps = {
  /** The curent URL of the page. */
  currentUrl: string,
  /**  Should we expand header text to the full width of the window? If not, we'll use a max-width */
  user?: HeaderUser,
  /** Location of the website url */
  urlPath?: string,
};

const platformPath = subPath => `${PLATFORM_ROOT}/${subPath}`;

const HEADER_NAV_USER_LINKS: HeaderNav = [
  { label: 'How to Build', href: platformPath('how-to-build') },
  { label: 'Partner Program', href: platformPath('partner-program') },
  { label: 'Documentation', href: 'https://platform.zapier.com/docs' },
];

const CTA_LINKS: HeaderNav = [
  { label: 'My Integrations', href: '/app/developer' },
  { label: 'Zap Templates', href: '/developer/zap-templates/' },
];

const isLinkActive = currentUrl => link =>
  link.href === currentUrl ? { ...link, isActive: true } : link;

/**
 * Platform branded header.
 *
 * *Note: for best results view this component in fullpage mode.*
 */
const Header = (props: HeaderProps) => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isUserOptsOpen, setUserOptsOpen] = useState(false);

  const toggleNav = useCallback(() => setIsNavOpen(val => !val), []);
  const toggleUserOptions = useCallback(() => setUserOptsOpen(val => !val), []);

  const { currentUrl, user, urlPath } = props;
  const activeLinkCheck = isLinkActive(currentUrl);

  const nav = HEADER_NAV_USER_LINKS.map(activeLinkCheck);
  const ctaLinks = user ? CTA_LINKS.map(activeLinkCheck) : [];

  return (
    <Layout
      ctaLinks={ctaLinks}
      isNavOpen={isNavOpen}
      isUserOptionsOpen={isUserOptsOpen}
      nav={nav}
      onToggleNav={toggleNav}
      onToggleUserOptions={toggleUserOptions}
      urlPath={urlPath}
      user={user}
    />
  );
};

export default Header;
